import { render, staticRenderFns } from "./RenewalProcessing.vue?vue&type=template&id=3f946d33"
import script from "./RenewalProcessing.vue?vue&type=script&lang=js"
export * from "./RenewalProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports